<template>
  <v-select
    :items="items"
    item-text="name"
    item-value="id"
    v-bind="$props"
    :value="role_id"
    @change="handleChange"
    cache-items
    clearable
    no-data-text="Nenhuma"
    :loading="loading"
  ></v-select>
</template>

<script>
export default {
  name: "role-select",
  model: {
    prop: "role_id",
    event: "change"
  },
  props: {
    label: String,
    role_id: Number,
    "error-messages": Array,
    disabled: Boolean,
    chips: Boolean
  },
  data: () => ({
    items: [],
    loading: false
  }),
  methods: {
    fetchData() {
      return this.$http.get("/roles");
    },
    async getItems() {
      this.loading = true;
      const response = await this.fetchData();
      this.items = response.data;
      this.loading = false;
    },
    handleChange(value) {
      this.$emit("change", value);
    }
  },
  created() {
    this.getItems();
  }
};
</script>